module.exports = __webpack_public_path__ + "media/images/Shape-6220a4b6.png";